import { useEffect, useRef, useState } from 'react';

const DEFAULT_INTERVAL_MS = 3500;

function shuffle(length: number): number[] {
    const order = Array.from({ length }, (_, i) => i);
    for (let i = order.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [order[i], order[j]] = [order[j], order[i]];
    }
    return order;
}

export function useRotatingDescription(
    items: string[],
    intervalMs = DEFAULT_INTERVAL_MS,
): string | null {
    const [tick, setTick] = useState(0);
    const orderRef = useRef<number[]>([]);
    const itemsRef = useRef(items);
    itemsRef.current = items;

    const contentKey = items.join('|');

    useEffect(() => {
        const list = itemsRef.current;
        if (list.length === 0) {
            orderRef.current = [];
            return;
        }
        orderRef.current = shuffle(list.length);
        setTick(0);

        if (list.length <= 1) return;
        const id = setInterval(() => setTick((prev) => prev + 1), intervalMs);
        return () => clearInterval(id);
    }, [contentKey, intervalMs]);

    if (items.length === 0) return null;
    const order = orderRef.current.length
        ? orderRef.current
        : items.map((_, i) => i);
    return items[order[tick % order.length] ?? 0] ?? null;
}
